export function scrollToElementId(elementID) {
    const element = document.getElementById(elementID);
    if (element) {
        element.scrollIntoView({behavior: 'smooth', block: 'center'});
    }
}
